export interface IPlanningWindowConfiguration {
  season: string;
  planningPeriodStartDate: string;
  planningPeriodEndDate: string;
  planningPeriodNoOfDays: number;
  planningPeriodNoOfWeeks: number;
  corPeriodStartDate: string;
  corPeriodEndDate: string;
  corPeriodNoOfWeeks: number;
  nextPeriodStartDate: string;
  nextPeriodEndDate: string;
  nextPeriodNoOfWeeks: number;
  activePreSeason: boolean;
  activeInSeason: boolean;
  targetPreSeason: boolean;
  targetInSeason: boolean;
}

export const Data = [
  {
    season: 'AW-19',
    planningPeriodStartDate: '08-05-2019',
    planningPeriodEndDate: '08-05-2019',
    planningPeriodNoOfDays: 0,
    planningPeriodNoOfWeeks: 0,
    corPeriodStartDate: '08-05-2019',
    corPeriodEndDate: '08-05-2019',
    corPeriodNoOfWeeks: 0,
    nextPeriodStartDate: '08-05-2019',
    nextPeriodEndDate: '08-05-2019',
    nextPeriodNoOfWeeks: 0,
    activePreSeason: true,
    activeInSeason: false,
    targetPreSeason: false,
    targetInSeason: true
  },
  {
    season: 'SS-19',
    planningPeriodStartDate: '02-03-2020',
    planningPeriodEndDate: '02-08-2020',
    planningPeriodNoOfDays: 5,
    planningPeriodNoOfWeeks: 0,
    corPeriodStartDate: '08-05-2019',
    corPeriodEndDate: '08-05-2019',
    corPeriodNoOfWeeks: 0,
    nextPeriodStartDate: '08-05-2019',
    nextPeriodEndDate: '08-05-2019',
    nextPeriodNoOfWeeks: 0,
    activePreSeason: false,
    activeInSeason: true,
    targetPreSeason: false,
    targetInSeason: true
  }
];
